import type {DirectiveBinding} from 'vue';


type CurrentElement = HTMLElement & {
  keydownListener?(event: KeyboardEvent): void;
};
/** Vue directive that translates arrow key presses into directional movement callbacks. */
export const moveSelection = {
  mounted(el: CurrentElement, binding: DirectiveBinding<(direction: 'horizontal' | 'vertical', amount: -1 | 1) => void>): void {
    function listener(event: KeyboardEvent): void {
      const {key} = event;
      if (key === 'ArrowUp') {
        binding.value('vertical', -1);
        event.preventDefault();
      } else if (key === 'ArrowDown') {
        binding.value('vertical', 1);
        event.preventDefault();
      } else if (key === 'ArrowLeft') {
        binding.value('horizontal', -1);
        event.preventDefault();
      } else if (key === 'ArrowRight') {
        binding.value('horizontal', 1);
        event.preventDefault();
      }
    }
    el.addEventListener('keydown', listener);
    el.keydownListener = listener;
  },
  beforeUnmount(el: CurrentElement): void {
    if (el.keydownListener) {
      // directive are functions with bound this, so we can ignore it
       
      el.removeEventListener('keydown', el.keydownListener);
      delete el.keydownListener;
    }
  },
};
